/* eslint-disable no-unused-vars */
import axios from "../../axios";

const state = {
  courses: [],
  courseLevels: [],
  totalRecords: 0,
  totalPages: 1,
  currentPage: 1,
  perPage: 10,
  isResetPage: false,
  courseDetail: null,
};

const actions = {
  /**
   * Get All course
   * @param commit
   * @param query
   * @returns {Promise<void>}
   */
  async getAllCourses({ commit }, query) {
    return new Promise((resolve, reject) => {
      axios
        .get(`curriculums/courses?${new URLSearchParams(query)}`)
        .then((response) => {
          commit("SET_ALL_COURSES", response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /**
   * get Course Levels
   * @param commit
   * @param query
   * @returns {Promise<void>}
   */
  async getCourseLevels({ commit }, { id, query, isCommit = true }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`curriculums/courses/${id}/levels?${new URLSearchParams(query)}`)
        .then((response) => {
          if (isCommit) {
            commit("SET_COURSE_LEVELS", response.data?.data?.items || []);
          }
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /**
   * Create course
   * @param commit
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  async createCourse({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post("curriculums/courses", payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /**
   * Update course
   * @param commit
   * @param payload
   * @returns {Promise<*>}
   */
  async updateCourse({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .put(`curriculums/courses/${payload.id}`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /**
   * deleteCourse
   * @param commit
   * @param payload
   * @returns {Promise<*>}
   */
  async deleteCourse({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`curriculums/courses/${payload.id}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /**
   * deleteCourseForever
   * @param commit
   * @param payload
   * @returns {Promise<*>}
   */
  async deleteCourseForever({ commit }, payload) {
    return await axios
      .post(`curriculums/courses/${payload.id}/delete-forever`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  },

  /**
   * changeStatusCourse
   * @param commit
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  async changeStatusCourse({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(`curriculums/courses/${payload.id}/change-status`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /**
   * restoreCourse
   * @param commit
   * @param payload
   * @returns {Promise<*>}
   */
  async restoreCourse({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(`curriculums/courses/${payload.id}/restore`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /**
   * getCourseDetail
   * @param commit
   * @param query
   * @returns {Promise<null|*>}
   */
  async getCourseDetail({ commit }, { id, query }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`curriculums/courses/${id}?${new URLSearchParams(query)}`)
        .then((response) => {
          commit("SET_COURSE_DETAIL", response.data.data);
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /**
   * setCurrentPage
   * @param commit
   * @param currentPage
   */
  setCurrentPage({ commit }, currentPage) {
    commit("SET_CURRENT_PAGE", currentPage);
  },

  /**
   * setPerPage
   * @param {*} param0
   * @param {*} perPage
   */
  setPerPage({ commit }, perPage) {
    commit("SET_PER_PAGE", perPage);
  },

  /**
   * Set reset page
   * @param {*} param0
   * @param {*} status
   */
  setStatusResetPage({ commit }, status) {
    commit("SET_RESET_PAGE", status);
  },
};

const mutations = {
  SET_ALL_COURSES(state, data) {
    state.courses = data.data;
    state.totalRecords = data.meta.total;
    state.totalPages = data.meta.last_page;
  },
  SET_CURRENT_PAGE(state, currentPage) {
    state.currentPage = currentPage;
  },
  SET_PER_PAGE(state, perPage) {
    state.perPage = perPage;
  },
  SET_RESET_PAGE(state, status) {
    state.isResetPage = status;
  },
  SET_COURSE_LEVELS(state, levels) {
    state.courseLevels = levels;
  },
  SET_COURSE_DETAIL(state, course) {
    state.courseDetail = course;
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
